/* GENERATED by tools/generators/locales.py out of `4. Backend/migrations/`.
 * DO NOT EDIT — a language typed onto a screen is a bug.
 *
 * LAUNCH (4) — what the APP'S OWN WORDS exist in. One answer:
 *   `users.preferred_language`. Al, 9 Sep 2026: "we keep the 3 in the
 *   dropdown."
 * MAJOR (29) — the curated headline set, offered as chips for
 *   `eleater_profiles.languages_spoken`. MANY answers.
 *
 * ⚠️ THE CHIPS ARE NOT THE WHOLE TABLE, ON PURPOSE. Migration 060 keeps
 * `languages_spoken_other` as free text so Hakka, Teochew, Nepali and
 * Punjabi can be typed. The chips are the sixteen; the box is the rest,
 * and it is the only place a language nobody listed can appear. */
export const LAUNCH = [
  {
    "code": "en",
    "label": "English",
    "native": "English"
  },
  {
    "code": "zh-HK",
    "label": "Cantonese",
    "native": "繁體中文 (香港)"
  },
  {
    "code": "zh-CN",
    "label": "Mandarin",
    "native": "简体中文"
  },
  {
    "code": "fr-CA",
    "label": "French (Canada)",
    "native": "Français (Canada)"
  }
];

export const MAJOR = [
  {
    "code": "en",
    "label": "English",
    "native": "English"
  },
  {
    "code": "zh-HK",
    "label": "Cantonese",
    "native": "繁體中文 (香港)"
  },
  {
    "code": "zh-CN",
    "label": "Mandarin",
    "native": "简体中文"
  },
  {
    "code": "fr-CA",
    "label": "French (Canada)",
    "native": "Français (Canada)"
  },
  {
    "code": "ar-AE",
    "label": "Arabic",
    "native": "العربية (الإمارات)"
  },
  {
    "code": "nl-NL",
    "label": "Dutch",
    "native": "Nederlands"
  },
  {
    "code": "fil-PH",
    "label": "Filipino",
    "native": "Filipino / Tagalog"
  },
  {
    "code": "fr-FR",
    "label": "French (France)",
    "native": "Français (France)"
  },
  {
    "code": "de-DE",
    "label": "German",
    "native": "Deutsch"
  },
  {
    "code": "gu-IN",
    "label": "Gujarati",
    "native": "ગુજરાતી"
  },
  {
    "code": "hi-IN",
    "label": "Hindi",
    "native": "हिन्दी"
  },
  {
    "code": "id-ID",
    "label": "Indonesian",
    "native": "Bahasa Indonesia"
  },
  {
    "code": "it-IT",
    "label": "Italian",
    "native": "Italiano"
  },
  {
    "code": "ja-JP",
    "label": "Japanese",
    "native": "日本語"
  },
  {
    "code": "ko-KR",
    "label": "Korean",
    "native": "한국어"
  },
  {
    "code": "ms-MY",
    "label": "Malay",
    "native": "Bahasa Melayu"
  },
  {
    "code": "pt-PT",
    "label": "Portuguese (Portugal)",
    "native": "Português (Portugal)"
  },
  {
    "code": "pa-IN",
    "label": "Punjabi",
    "native": "ਪੰਜਾਬੀ"
  },
  {
    "code": "ru-RU",
    "label": "Russian",
    "native": "Русский"
  },
  {
    "code": "es-ES",
    "label": "Spanish",
    "native": "Español (España)"
  },
  {
    "code": "th-TH",
    "label": "Thai",
    "native": "ไทย"
  },
  {
    "code": "tr-TR",
    "label": "Turkish",
    "native": "Türkçe"
  },
  {
    "code": "ur-PK",
    "label": "Urdu",
    "native": "اردو"
  }
];
